const CustomersEndpoint = {
  index () {
    return {
      url: '/customers',
      method: 'GET',
    }
  },
  show(customer_id) {
    return {
      url: `/customers/${customer_id}`,
      method: 'GET'
    }
  }
}

export default CustomersEndpoint



// WEBPACK FOOTER //
// ./src/persistence/CustomerEndpoint.js